export default "__VITE_ASSET__dCxONPG6__"